/**
 * @ngdoc object
 * @name auth.controller:ActivationCtrlCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.auth')
    .controller('AuthBaseCtrl', [
        '$state',
        BaseController
    ]);

function BaseController($state) {
    var vm = this;

    vm.state = $state;
}



// WEBPACK FOOTER //
// ./src/app/pages/auth/controllers/base-controller.js